(($, Drupal) => {
  Drupal.behaviors.kabParentClass = {
    attach: (context) => {

      const $locationSelect = $('#location-select', context);
      const $viewMoreLink = $('.parent-class__view-more', context);

      $(once('location-select', $locationSelect)).on('change', function() {
          let count = 0;
          let $value = $locationSelect.val();
          
          // On change, loop through each row.
          $('.class-instance-row', context).each(function() {
            let $instance = $(this);

            // Show rows based on location.
            if ($value == 'all') {
              $instance.removeClass('hide-instance');
            }
            else {
              $instance.data('abbreviation') == $value ? $instance.removeClass('hide-instance') : $instance.addClass('hide-instance');
            }

            // Keep track of how many rows are displaying for this location.
            if ($instance.hasClass('hide-instance') == false) {
              count++;
            }

            // Show/hide each row after location change.
            if ($viewMoreLink.attr('aria-expanded') == 'true') {
              $instance.removeClass('hide-by-view-more');
            }
            else {
              if ($instance.hasClass('hide-instance') == false) {
                (count > 5) ? $instance.addClass('hide-by-view-more') : $instance.removeClass('hide-by-view-more');
              }
            }
          });

          // Remove top-level CSS class, row display is now handled with JS.
          $('.parent-class__class-list', context).removeClass('hide-instances');

          // Hide View More link if there are fewer than 6 rows for the selected location.
          (count > 5) ? $viewMoreLink.show() : $viewMoreLink.hide();
      });
    }
  };

  Drupal.behaviors.kabParentClassUrlParams = {
    attach: (context) => {
      const $classList = $('.parent-class__class-list', context);
      const $locationSelect = $('#location-select', context);
      const $viewMoreLink = $('.parent-class__view-more', context);

      // Allow URL params to trigger select element, e.g. ?class_location=washington .
      $(once('url-param-select', $classList)).each(function () {
        const urlParams = new URLSearchParams(location.search);
        if (urlParams.has('class_location') && $locationSelect.length > 0) {
          const classLocation = urlParams.get('class_location').toLowerCase();
          $('#location-select option', context).each(function() {
            $this = $(this);
            if ($this.text().toLowerCase() == classLocation) {
              $val = $this.val();
              $locationSelect.val($val).change();
            }
          });
        }
        else {
          // If there are no query params or there is no select element, then immediately hide/show link.
          $('.class-instance-row', context).length > 5 ? $viewMoreLink.show() : $viewMoreLink.hide();
        }
      });
    }
  };

  Drupal.behaviors.kabParentClassViewMore = {
    attach: (context) => {

      const $viewMoreLink = $('.parent-class__view-more', context);
      $(once('vm', $viewMoreLink)).click(function(e) {
        e.preventDefault();
        let count = 0;

        // Remove top-level CSS class, row display is now handled with JS.
        $('.parent-class__class-list', context).removeClass('hide-instances');

        // Update text and aria text.
        $link = $(this);
        if ($link.is(':contains("More")')) {
          $link.attr('aria-expanded', true)
          $link.text('See Fewer Dates & Waitlists');
        }
        else {
          $link.attr('aria-expanded', false)
          $link.text('See More Dates & Waitlists');
        }

        // Adjust class instance row display.
        $('.class-instance-row', context).each(function () {
          $instance = $(this);
          if ($viewMoreLink.attr('aria-expanded') == 'true') {
            $instance.removeClass('hide-by-view-more');
          }
          else {
            if ($instance.hasClass('hide-instance') == false) {
              count++;
              if (count > 5) {
                $instance.addClass('hide-by-view-more');
              }
              else {
                $instance.removeClass('hide-by-view-more');
              }
            }
          }
        });
      });
    }
  };

  Drupal.behaviors.kabParentClassEnrollment = {
    attach: (context) => {

      $class_instance_row = $('.parent-class__class-list .class-instance-row', context);
      $(once('enroll', $class_instance_row)).each(function () {
        $instance = $(this);
        var $activityId = $instance.attr('data-activity-id');
        var $scheduleRowId = $instance.attr('data-schedule-row-id');
        var $enrollDate = $instance.attr('data-enroll-date');
        var $nextDate = $instance.attr('data-next-date');
        outboundRequest($activityId, $scheduleRowId, $enrollDate, $nextDate, $instance);
      });

      function outboundRequest($activity_id, $schedule_row_id, $enroll_date, $next_date, $instance) {
        var settings = {
          "crossDomain": true,
          "url": "https://classes.kingarthurbaking.com/api/Service1.asmx?WSDL",
          "method": "POST",
          "headers": {
            "Content-Type": "text/xml",
          },
          "data": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<soap12:Envelope xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xmlns:xsd=\"http://www.w3.org/2001/XMLSchema\" xmlns:soap12=\"http://www.w3.org/2003/05/soap-envelope\">\n  <soap12:Body>\n    <GetScheduleJSON xmlns=\"Outbound\">\n       <ActivityID>" + $activity_id + "</ActivityID>\n      <StartDate>" + $enroll_date + "</StartDate>\n      <EndDate>" + $next_date + "</EndDate>\n    </GetScheduleJSON>\n  </soap12:Body>\n</soap12:Envelope>"
        };
        $.ajax(settings).done(function (response) {
          var resultValue = $(response).find("GetScheduleJSONResult").text();
          var resultArray = JSON.parse(resultValue);
          if (resultArray[0] == undefined) {
            return;
          }
          resultArray.forEach((result) => {
            if ($schedule_row_id == result['SCHEDULE ROW ID']) {
              var seats = result['SCHEDULE AVAILABLE'];
              var $enrollmentDiv = $instance.find('.class-enrollment', context);
              if (seats == 1) {
                $enrollmentDiv.text(seats + ' Spot Available');
              }
              else if (seats > 1) {
                $enrollmentDiv.text(seats + ' Spots Available');
              }
              else {
                var $btn = $instance.find('.btn');
                $enrollmentDiv.text('Class Full');
                $btn.text('Waitlist');
                $btn.addClass('btn--secondary');
                $btn.addClass('class-waitlist-link');
                $btn.removeClass('class-register-link');
                $btn.attr('aria-label', $btn.attr('aria-label').replace('Register', 'Waitlist'));
              }
            }
          });
        });
      };

    },
  };
})(jQuery, Drupal);
